"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1Stronger: function() {
        return _index.Caption1Stronger;
    },
    caption1StrongerClassNames: function() {
        return _index.caption1StrongerClassNames;
    }
});
const _index = require("./components/presets/Caption1Stronger/index");
